export default __webpack_public_path__ + "static/media/card.f419e3ab.png";